import { render, staticRenderFns } from "./debtManagement.vue?vue&type=template&id=656645ee"
import script from "./debtManagement.ts?vue&type=script&lang=js&external"
export * from "./debtManagement.ts?vue&type=script&lang=js&external"
import style0 from "./debtManagement.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports